module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"createCustomer.title":"Create Customer","createCustomer.customerName.label":"Customer Name","createCustomer.successfulAdd":"Customer successfully added.","createCustomer.customerIsNotForProfit.label":"Customer is a registered charity or not-for-profit."}}')
  delete Component.options._Ctor
}
